// src/models/Company.js

class Dispositivo {
    constructor({
      id = null,
      name = '',
  
      model = '',
      ip_address = '',
      port = '',
    
      password = '',
      description = '',
      create_at = '',
      sucursal ='',
      servicio = '',

    }) {
      this.id = id;
      this.name = name;
    
      this.model = model;
      this.ip_address = ip_address;
      this.port = port;

      this.password = password;
    
      this.description = description;
      this.create_at = create_at;
      this.sucursal = sucursal;
      this.servicio = servicio;

     
    }
  
    // Método para actualizar los datos de la empresa
    update(data) {
      Object.assign(this, data);
    }
  }
  
  export default Dispositivo;
  